import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import TyphoonService from '@/api/typhoon-service.js';
import Vue from 'vue';
var typhoonLimitCount = 30; //

export default {
  namespace: true,
  state: {
    typhoon_year_list: [],
    // 年份列表数据
    typhoon_history_list: [],
    // 历史列表台风数据，根据年份进行索引
    draw_path_info: {},
    // 需要绘制的台风信息
    typhoon_cache_data: {},
    // 选中的台风数据列表
    typhoon_select_status: {},
    // 选中的台风状态数据
    typhoon_select_point_list: [],
    // 默认选中台风所有点列表，用于触发更新
    light_history_tfbh: null // 高亮某一号历史台风

  },
  mutations: {
    // 提交缓存选择数据
    SET_TYPHOON_CACHE_DATA: function SET_TYPHOON_CACHE_DATA(state, _ref) {
      var tfbh = _ref.tfbh,
          data = _ref.data;

      if (!state.typhoon_cache_data[tfbh]) {
        Vue.set(state.typhoon_cache_data, tfbh, data);
      } else {
        Vue.delete(state.typhoon_cache_data, tfbh); // 删除操作要把高亮台风回退，点也要回退
      }
    },
    // 更新高亮台风选中台风
    UPDATE_LIGHT_TFBH: function UPDATE_LIGHT_TFBH(state, tfbh) {
      state.light_history_tfbh = tfbh;
    },
    // 更新路径点信息集合
    UPRDATE_POINTS_LIST: function UPRDATE_POINTS_LIST(state, list) {
      state.typhoon_select_point_list = list;
    },
    UPDATE_TYPHOON_HISTORY_LIST: function UPDATE_TYPHOON_HISTORY_LIST(state, data) {
      state.typhoon_history_list = data;
    },
    // 选中台风数据
    UPDATE_SELECT_TYPHOON_STATUS: function UPDATE_SELECT_TYPHOON_STATUS(state, _ref2) {
      var tfbh = _ref2.tfbh,
          data = _ref2.data;

      if (state.typhoon_select_status[tfbh]) {
        Vue.delete(state.typhoon_cache_data, tfbh);
        Vue.delete(state.typhoon_select_status, tfbh); // 取消操作要告知回退的台风编号和点信息

        var arr = Object.keys(state.typhoon_cache_data); // 数据源

        var item = arr[0];
        state.light_history_tfbh = item || null; // 高亮台风信息

        state.typhoon_select_point_list = state.typhoon_cache_data[item] ? state.typhoon_cache_data[item].points : [];
        state.draw_path_info = {
          status: false,
          tfbh: tfbh
        }; // 通知绘制路径
      } else {
        // 慢了一次设置
        if (Object.keys(state.typhoon_cache_data).length >= typhoonLimitCount) {
          window.alert("\u6700\u591A\u53EA\u80FD\u9009\u4E2D".concat(typhoonLimitCount, "\u53F7\u53F0\u98CE\u54E6~"));
          return;
        }

        Vue.set(state.typhoon_cache_data, tfbh, data);
        Vue.set(state.typhoon_select_status, tfbh, true);
        state.light_history_tfbh = tfbh; // 高亮某一号

        state.typhoon_select_point_list = state.typhoon_cache_data[tfbh].points; // 点集合

        state.draw_path_info = {
          status: true,
          tfbh: tfbh
        };
      }
    }
  },
  actions: {
    /**
     * 获取台风年份列表
     */
    GetTyphoonYearList: function () {
      var _GetTyphoonYearList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
        var state;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref3.state;
                _context.next = 3;
                return TyphoonService.getTyphoonYearList();

              case 3:
                state.typhoon_year_list = _context.sent;
                return _context.abrupt("return", state.typhoon_year_list);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function GetTyphoonYearList(_x) {
        return _GetTyphoonYearList.apply(this, arguments);
      }

      return GetTyphoonYearList;
    }(),

    /**
    * 获取当年台风列表
    */
    GetTyphoonListNow: function () {
      var _GetTyphoonListNow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
        var commit, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref4.commit;
                _context2.next = 3;
                return TyphoonService.getTyphoonPathNow();

              case 3:
                res = _context2.sent;
                commit('UPDATE_TYPHOON_HISTORY_LIST', res);
                return _context2.abrupt("return", res);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetTyphoonListNow(_x2) {
        return _GetTyphoonListNow.apply(this, arguments);
      }

      return GetTyphoonListNow;
    }(),

    /**
    * 根据年份获取台风列表
    */
    GetTyphoonListByYear: function () {
      var _GetTyphoonListByYear = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5, id) {
        var state;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref5.state;
                _context3.next = 3;
                return TyphoonService.getTyphoonPathByID(id);

              case 3:
                state.typhoon_history_list = _context3.sent;
                return _context3.abrupt("return", state.typhoon_history_list);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetTyphoonListByYear(_x3, _x4) {
        return _GetTyphoonListByYear.apply(this, arguments);
      }

      return GetTyphoonListByYear;
    }(),

    /**
    * 这里初始化一些台风数据，包括选中状态等
    * @param {*} param0
    * @param {*} param1
    */
    InitTyphoonState: function InitTyphoonState(_ref6) {
      var commit = _ref6.commit;
    },
    // 通过点击路径点更新历史信息
    UpdateHistoryPointByPath: function UpdateHistoryPointByPath(_ref7, tfbh) {
      var state = _ref7.state,
          commit = _ref7.commit;
      commit('UPDATE_LIGHT_TFBH', tfbh);
      commit('UPRDATE_POINTS_LIST', state.typhoon_cache_data[tfbh].points);
    },

    /**
    * 根据台风编号获取台风信息
    * @status 选中和取消标识,选中绘制路径
    * @tfbh 台风编号
    */
    GetTyphoonDetailByTfbh: function () {
      var _GetTyphoonDetailByTfbh = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref8, _ref9) {
        var state, tfbh, arr, item, res, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                state = _ref8.state;
                tfbh = _ref9.tfbh;

                if (!state.typhoon_select_status[tfbh]) {
                  _context4.next = 12;
                  break;
                }

                Vue.delete(state.typhoon_cache_data, tfbh);
                Vue.delete(state.typhoon_select_status, tfbh); // 取消操作要告知回退的台风编号和点信息

                arr = Object.keys(state.typhoon_cache_data); // 数据源

                item = arr[0];
                state.light_history_tfbh = item || null; // 高亮台风信息

                state.typhoon_select_point_list = state.typhoon_cache_data[item] ? state.typhoon_cache_data[item].points : [];
                state.draw_path_info = {
                  status: false,
                  tfbh: tfbh
                }; // 通知绘制路径

                _context4.next = 24;
                break;

              case 12:
                _context4.next = 14;
                return TyphoonService.getTyphoonPathByID(tfbh);

              case 14:
                res = _context4.sent;
                data = res[0]; // 慢了一次设置

                if (!(Object.keys(state.typhoon_cache_data).length >= typhoonLimitCount)) {
                  _context4.next = 19;
                  break;
                }

                window.alert("\u6700\u591A\u53EA\u80FD\u9009\u4E2D".concat(typhoonLimitCount, "\u53F7\u53F0\u98CE\u54E6~"));
                return _context4.abrupt("return");

              case 19:
                Vue.set(state.typhoon_cache_data, tfbh, data);
                Vue.set(state.typhoon_select_status, tfbh, true);
                state.light_history_tfbh = tfbh; // 高亮某一号

                state.typhoon_select_point_list = state.typhoon_cache_data[tfbh].points; // 点集合

                state.draw_path_info = {
                  status: true,
                  tfbh: tfbh
                };

              case 24:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetTyphoonDetailByTfbh(_x5, _x6) {
        return _GetTyphoonDetailByTfbh.apply(this, arguments);
      }

      return GetTyphoonDetailByTfbh;
    }()
  }
};